<template>
  <div>
    <BaseVeeForm :action="update" v-slot="{ isPending, invalid }">
      <BaseLayoutSpaced relaxed>
        <div class="flex -mx-4">
          <div class="w-1/3 px-4">
            <ValidationProvider
              name="dateStart"
              vid="dateStart"
              rules="required"
              v-slot="{ errors, failed }"
              slim
            >
              <BaseFormGroup>
                <BaseFormLabel for="date_start"> Starts at </BaseFormLabel>
                <BaseFormInput
                  id="date_start"
                  type="date"
                  :disabled="isPending"
                  v-model="data.dateStart"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </ValidationProvider>
          </div>
          <div class="w-1/3 px-4">
            <ValidationProvider name="dateEnd" vid="dateEnd" v-slot="{ errors, failed }" slim>
              <BaseFormGroup>
                <BaseFormLabel for="date_end"> Ends at </BaseFormLabel>
                <BaseFormInput
                  id="date_end"
                  type="date"
                  :disabled="isPending"
                  v-model="data.dateEnd"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </ValidationProvider>
          </div>
        </div>
        <div class="flex -mx-4">
          <div class="px-4">
            <label for="dates_visible_on_calendar" class="inline-block font-medium text-sm mb-2"
              >Dates Visible on Calendar</label
            >
            <div class="flex">
              <label v-for="(option, idx) in calendarOptions" :key="idx" class="relative">
                <input
                  v-model="data.datesVisibleOnCalendar"
                  :value="option.value"
                  :disabled="isPending"
                  type="radio"
                  name="datesVisibleOnCalendar"
                  class="field opacity-0 absolute inset-0 w-full h-full"
                />
                <span
                  :class="{
                    'rounded-l': idx === 0,
                    'rounded-r': idx === calendarOptions.length - 1,
                  }"
                  class="inline-block px-3 py-2 bg-gray-300 leading-6 field-checked:bg-blue-600 field-checked:text-white transition-colors duration-75"
                >
                  {{ option.label }}
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="flex space-x-2 py-1 items-baseline">
          <BaseButton primary type="submit" :disabled="isPending || invalid">
            <span v-if="!isPending">Ενημέρωση</span>
            <Loader v-else small inverse />
          </BaseButton>
        </div>
      </BaseLayoutSpaced>
    </BaseVeeForm>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

const defaultData = {
  dateStart: null,
  dateEnd: null,
  datesVisibleOnCalendar: 'both',
};

export default {
  name: 'TabSchedule',
  mixins: [veeValidateErrorsMixin],
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    data: { ...defaultData },
    calendarOptions: [
      {
        value: null,
        label: 'None',
      },
      {
        value: 'both',
        label: 'Both',
      },
      {
        value: 'start',
        label: 'Starts at',
      },
      {
        value: 'end',
        label: 'Ends at',
      },
    ],
  }),
  created() {
    Object.keys(defaultData).forEach((prop) => {
      if (this.campaign[prop] !== undefined) {
        this.data[prop] = this.campaign[prop];
      }
    });
  },
  methods: {
    ...mapActions('ui/campaigns', ['updateCampaignSchedule']),
    async update() {
      try {
        await this.updateCampaignSchedule({
          campaignId: this.campaign.id,
          scheduleData: this.data,
        });

        if (this.closeOnSuccess) {
          this.$refs.modal.doClose();
        }

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
